namespace JupitersChoice {
    export class FireBowl extends PIXI.Container {

        @inject('AssetCache') _assetCache: Sapphire.AssetCache;

        private _fireAnim: Sapphire.AnimatedSprite;
        private _data: Sapphire.DataHelper;

        private _shouldPlay: boolean = false;

        construct(data: any): void {

            this._data = new Sapphire.DataHelper(data);

            //bowl
            var bowlFrame: string = data.bowl || ['BaseGame','reelComponents','bowl.png'];
            var bowlOffset: number = data.bowlOffset || 20;
            var bowl:PIXI.Sprite = new PIXI.Sprite(this._assetCache.getTexture(bowlFrame[0],bowlFrame[1],bowlFrame[2]));
            bowl.pivot = new PIXI.Point(bowl.width/2,bowl.height);
            
            //fire
            var fireData =  {
                animationSpeed: 0.3,
                loop: true,
                bundle: "BaseGame",
                spritesheet: "flame",
            };
            this._fireAnim = new Sapphire.AnimatedSprite();
            this._fireAnim.construct(fireData,this._assetCache);
            this._fireAnim.pivot = new PIXI.Point(this._fireAnim.width/2,0);

            if(data.reverseOrder){
                this.addChild(this._fireAnim);
                this.addChild(bowl);
            }else{
                this.addChild(bowl);
                this.addChild(this._fireAnim);
            }

            bowl.y = this._fireAnim.height + bowlOffset;
            this.pivot = new PIXI.Point(0,this.height);

            this.updateLayout();
        }

        private updateLayout(): void {
            this.x = this._data.get('x',this.x);
            this.y = this._data.get('y',this.y);
            
            this.pivot = this._data.get('pivot',this.pivot);
            this.scale = this._data.get('scale', {x: 1, y: 1});

            if(this._data.get('visible',this.visible)){
                this.show();
            }else{
                this.hide();
            }
        }

        
        setOrientation(orientation: string): void {
            this._data.orientation = orientation;
            this.updateLayout();
        }

        private checkAndPlay(){
            if(this._shouldPlay && this.visible){
                this._fireAnim.play();
                if(Sapphire.Browser.isIE){
                    this._fireAnim.skipToFrame(20);
                }
            }else{
                this._fireAnim.stop();
            }
        }

        show() {
            if(this._data.get('visible',true)){
                this.visible=true;
                this.checkAndPlay();
            }
        }

        hide() {
            this.visible=false;
            this.checkAndPlay();
        }

        play() {
            this._shouldPlay = true;
            this.checkAndPlay();
        }

        stop() {
            this._shouldPlay = false;
            this.checkAndPlay();
        }
    }
}